import * as React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import InputGroup from '../inputGroup/InputGroup';

// tslint:disable-next-line:variable-name
const SDropdownWrap = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 800px) {
    flex-basis: 0;
  }
`;

// tslint:disable-next-line:variable-name
const SDropdown = styled(Select)<{ error: string; dropdownListHeight: string }>(
  ({ theme, error, dropdownListHeight }) => ({
    position: 'relative',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    '.dropDown__control': {
      fontFamily: 'Poppins',
      height: '40px',
      backgroundColor: `${error.length ? 'white' : '#F1F3F5'}`,
      border: `1px solid ${error.length ? '#ED726B' : '#F1F3F5'}`,
      borderRadius: theme.borderRadiusCommon,
      position: 'relative',
      cursor: 'pointer',
      boxShadow: 'none' /* override  */,
      '&:hover': {
        border: `solid ${error ? `#ED726B 1.5px` : `#F1F3F5 1px`}`,
      },
      '&:focus': {
        backgroundColor: 'white',
      },
    },
    '.dropDown__menu-list': {
      fontFamily: 'Poppins',
      height: `${dropdownListHeight || 'auto'}`,
      '& div': {
        fontFamily: 'Poppins',
        textAlign: 'left',
      },
    },
    '.dropDown__value-container': {
      fontFamily: 'Poppins',
      height: '40px',
      fontWeight: 500,
      fontSize: '16px',
      boxSizing: 'border-box',
      color: '#002169',
      backgroundColor: 'transparent',
      borderWidth: 0,
      padding: '9px 8px',
      gap: '10px',
      div: {
        margin: 0,
        padding: 0,
        fontWeight: 500,
        fontSize: '16px',
      },
    },
    '.dropDown__dropdown-indicator': {
      color: '#002169',
    },
    '.dropDown__indicator-separator': {
      display: 'none',
    },
    '.dropDown__single-value': {
      fontFamily: 'Poppins',
      color: '#002169',
    },
    '.dropDown__placeholder': {
      fontFamily: 'Poppins',
      fontWeight: 500,
      color: '#8B939E',
      fontSize: '16px',
      position: 'absolute',
      margin: 0,
      top: 'auto',
      transform: 'initial',
      div: {
        margin: 0,
      },
    },
  })
);

const permanentScrollbar = {
  '::-webkit-scrollbar': {
    width: '7px',
  },
  '::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '5px',
    minHeight: '30px',
  },
};

export interface IDropdownOptionForSelect<T> {
  label: string;
  value: T;
}

export interface IDropdownProps<T> {
  onChange: (selectedOption: IDropdownOptionForSelect<T>, name: string) => void;
  name: string;
  placeholder?: string;
  value: T;
  dropdownOptions: Array<IDropdownOptionForSelect<T>>;
  dataAt?: string;
  className?: string;
  label?: string | React.ReactChild;
  tooltipContent?: string;
  error?: string;
  dropdownListHeight?: string;
  permanentScrollbar?: boolean;
  disabled?: boolean;
  isMulti?: boolean;
}

class Dropdown<T> extends React.Component<IDropdownProps<T>> {
  public handleOnChange = (selectedOption: IDropdownOptionForSelect<T>) => {
    this.props.onChange(selectedOption, this.props.name);
  };

  public render() {
    const placeholder = this.props.placeholder || this.props.name.replace(/^\w/, (c) => c.toUpperCase());
    let selecedOption = null;

    if (this.props.value && this.props.dropdownOptions && this.props.dropdownOptions.length) {
      selecedOption = this.props.dropdownOptions.find((item) => {
        return item.value === this.props.value;
      });
    }

    const menuList = (base) => {
      if (this.props.permanentScrollbar) {
        return {
          ...base,
          ...permanentScrollbar,
        };
      }
      return base;
    };

    return (
      <SDropdownWrap data-at={this.props.dataAt} className={this.props.className}>
        <InputGroup
          className={this.props.className}
          dataAt={`${this.props.dataAt}-group`}
          tooltipContent={this.props.tooltipContent || ''}
          label={this.props.label}
          error={this.props.error || ''}
        >
          <SDropdown
            classNamePrefix="dropDown"
            /*@ts-ignore*/
            dataAt={`${this.props.dataAt}-select`}
            options={this.props.dropdownOptions}
            placeholder={placeholder}
            onChange={this.handleOnChange}
            value={selecedOption}
            error={this.props.error || ''}
            dropdownListHeight={this.props.dropdownListHeight || ''}
            styles={{ menuList }}
            isDisabled={this.props.disabled}
            isMulti={this.props.isMulti}
          />
        </InputGroup>
      </SDropdownWrap>
    );
  }
}

export default Dropdown;
